// extracted by mini-css-extract-plugin
export default {"AddOrEditData":"styles_AddOrEditData__gs2gW","col":"styles_col__yfche","switchContainer":"styles_switchContainer__3QxMA","fullWidth":"styles_fullWidth__k4ArQ"};